// test647
(647 && 0);
